module.exports = __webpack_public_path__ + "img/numbered-steps.3f2fc725.png";